import styled from "styled-components";

export const ParticipantDetailsDiv = styled.div`
    label[for] {
        font-weight: 500;
    }

    margin-bottom: 30px;
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(0,0,0,0.1);
`;
